import type { IGetCreativesData, IResponse } from '@api/types';
import { isGlobalDomain } from '@config/globalDomain';
import type { IForm, ICreativeState } from './interfaces';

import { ORD_FORM_TYPES } from './config';

export const prepareFormFields = (
    form: IForm,
    defaultCreativeName: string,
    isAli: boolean,
): IForm => ({
    type: 'deeplink',
    description: form.description || defaultCreativeName,
    link: form.link,
    offerId: form.offerId,
    ordForm: form.ordForm,
    ordDescription: form.ordDescription,
    ordRimDescription: form.ordRimDescription,
    ordText: form.ordText,
    ...(form.placementId && { placementId: form.placementId }),
    ...(form.ordForm !== ORD_FORM_TYPES.text && { ordRim: form.ordRim }),
    ...(isAli && {
        ...(form.material && { material: form.material }),
        ...(form.sub && { sub: form.sub }),
        ...(form.sub2 && { sub2: form.sub2 }),
        ...(form.sub3 && { sub3: form.sub3 }),
        ...(form.sub4 && { sub4: form.sub4 }),
        ...(form.sub5 && { sub5: form.sub5 }),
    }),
});

export const prepareCreativeData = (
    creativeData: IResponse<IGetCreativesData>,
    form: IForm,
): ICreativeState => {
    const {
        data: {
            attributes: { ordClientFullName, ordClientInn, code, erid, aliArticle },
        },
    } = creativeData;
    const INNText = isGlobalDomain ? 'TAX number/VAT number' : 'ИНН';
    const AdvertText = isGlobalDomain ? 'Advert' : 'Реклама';
    const ordFullData = erid
        ? `${AdvertText}: ${ordClientFullName} ${INNText}: ${ordClientInn}`
        : '';

    return {
        code,
        erid,
        ordFullData,
        link: form.link,
        aliArticle,
    };
};
